/**
 * Controls pagination on the cart page
 */
export const CART_PAGINATION_WEB_240627 = 'CART_PAGINATION_WEB_240627';
